import { ArrowTrendingUpIcon } from '@heroicons/react/24/outline';
import type { ReactNode } from 'react';

interface KpiCardProps {
  title: string;
  value: string;
  delta?: string;
  icon?: ReactNode;
  trendLabel?: string;
}

export function KpiCard({ title, value, delta, icon, trendLabel }: KpiCardProps): JSX.Element {
  return (
    <article className="glass-card group flex flex-col justify-between gap-4 p-4 transition hover:-translate-y-0.5 hover:shadow-lg">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs uppercase tracking-[0.12em] text-muted-foreground">{title}</p>
          <p className="mt-2 text-3xl font-semibold text-foreground">{value}</p>
        </div>
        <div className="rounded-full border border-white/10 bg-white/40 p-2 text-primary dark:bg-white/10">
          {icon ?? <ArrowTrendingUpIcon className="h-5 w-5" />}
        </div>
      </div>
      {delta && (
        <div className="flex items-center gap-2 text-sm text-primary">
          <span className="font-medium">{delta}</span>
          <span className="text-muted-foreground">{trendLabel ?? 'vs last period'}</span>
        </div>
      )}
    </article>
  );
}
